import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import IpBlockedListSection from "../../Sections/IpBlockedList";

const IpBlockedListComponent = () => {
    return (
        <Dashboard sectionName={<IpBlockedListSection />} />
    );
};

export default IpBlockedListComponent;
